import { render, staticRenderFns } from "./WizardContentMediaRotater.vue?vue&type=template&id=5f34224d&scoped=true&"
import script from "./WizardContentMediaRotater.vue?vue&type=script&lang=ts&"
export * from "./WizardContentMediaRotater.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentMediaRotater.vue?vue&type=style&index=0&id=5f34224d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34224d",
  null
  
)

export default component.exports